import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ApiRouterService } from '../http/api.router';
import { BaseHttpService } from '../http/base.http.service';
import { IBookingScheduler } from 'src/app/models';
import { objectToSnake } from 'ts-case-convert';

@Injectable({
  providedIn: 'root',
})
export class BookingsSchedulersHttpService extends BaseHttpService {
  private baseURL = `booking-schedulers`;

  constructor(
    @Inject(HttpClient) httpClient: HttpClient,
    private routerService: ApiRouterService,
  ) {
    super(httpClient);
  }

  public getBookingSchedulersById(bookingId: number) {
    const url = this.routerService.mount(`${this.baseURL}/${bookingId}`);
    return this.read(url);
  }

  public getBookingSchedulersByFavourite(favouriteId: number) {
    const url = this.routerService.mount(`${this.baseURL}/favorite/${favouriteId}`);
    return this.read(url);
  }

  public getBookingSchedulersByUserId(userId: number, page: number, size?: number) {
    let path = page ? `?page=${page}` : '';
    path +=
      path === '' ? (size ? `?size=${size}` : '') : size ? `&size=${size}` : '';
    const url = this.routerService.mount(`${this.baseURL}/user/${userId}${path}`);
    return this.read(url);
  }

  public createBookingScheduler(bookingScheduler: IBookingScheduler) {
    const body = objectToSnake(bookingScheduler);
    const url = this.routerService.mount(`${this.baseURL}`);
    return this.create(body, url);
  }

  public updateBookingScheduler(bookingScheduler: IBookingScheduler) {
    const body = objectToSnake(bookingScheduler);
    const url = this.routerService.mount(`${this.baseURL}`);
    return this.update(body, url);
  }

  public deleteBookingScheduler(bookingSchedulerId: number) {
    const url = this.routerService.mount(`${this.baseURL}/${bookingSchedulerId}`);
    return this.delete(url);
  }
}
